import React from "react";
import logo from "../assets/logo.png";

const Spinner = ({ className }) => {
  return (
    <div id="page" className={`${className}`}>
      <div id="container">
        <div id="ring"></div>
        <div id="ring"></div>
        <div id="ring"></div>
        <div id="ring"></div>
        <div className={`h-32 w-32 mt-16 `}>
          {" "}
          <img src={logo} className="animate-ping" alt="spinner" />
        </div>
      </div>
    </div>
  );
};

export default Spinner;
